import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";

// Auto-detect low-end devices (car head units typically) and apply a
// lite-mode class that strips the backdrop-blur, pulse animations and
// other compositor-heavy effects. These devices have very little GPU
// memory and Chromium spams "tile memory limits exceeded" otherwise.
// Manual override: append `?lite=1` (force on) or `?lite=0` (force off).
function detectLiteMode(): boolean {
  try {
    const params = new URLSearchParams(location.search);
    if (params.get("lite") === "1") return true;
    if (params.get("lite") === "0") return false;
  } catch {}
  const nav = navigator as Navigator & { deviceMemory?: number };
  const mem = nav.deviceMemory;
  const cores = nav.hardwareConcurrency;
  if (typeof mem === "number" && mem <= 4) return true;
  if (typeof cores === "number" && cores <= 4) return true;
  return false;
}
if (detectLiteMode()) {
  document.documentElement.classList.add("lite");
  // Console-visible diagnostic so chrome://inspect makes lite-mode
  // engagement obvious without digging through the DOM.
  // eslint-disable-next-line no-console
  console.log(
    "[CarDash] Lite mode ON — deviceMemory=%s cores=%s. Override with ?lite=0",
    (navigator as Navigator & { deviceMemory?: number }).deviceMemory,
    navigator.hardwareConcurrency,
  );
} else {
  // eslint-disable-next-line no-console
  console.log("[CarDash] Full mode (lite OFF). Force lite with ?lite=1");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
